import React from 'react';
import objStr from 'obj-str';
import { useOverflowHidden } from '@/hooks/useOverflowHidden';
import { useBrowserLayoutEffect } from '@/hooks/useBrowserLayoutEffect';
import styles from './FullPageScrollPane.module.scss';

interface IFullPageScrollPane {
  PageHeader?: React.ReactNode;
  PageFooter?: React.ReactNode;
  children: React.ReactNode;
  trueFullScreen?: boolean;
  isOpen?: boolean;
  className?: string;
}

export const FullPageScrollPane = ({ PageHeader, PageFooter, children, trueFullScreen, isOpen, ...rest }: IFullPageScrollPane) => {
  useOverflowHidden(isOpen);

  useBrowserLayoutEffect(() => {
    if (isOpen) {
      document.body.classList.toggle('isFullPageScrollpaneOpen');
    }
    return () => document.body.classList.remove('isFullPageScrollpaneOpen');
  }, [isOpen]);

  const classNames = objStr({
    'full-page': true,
    [styles.fullPage]: true,
    [styles.trueFullScreen]: trueFullScreen,
    [styles.isOpen]: isOpen,
    ...(rest?.className ? { [rest.className]: true } : {})
  });
  return (
    <div className={classNames}>
      {PageHeader && <div className={styles.fullPageHeader}>{PageHeader}</div>}

      <div className={`${styles.fullPageScrollPane}`}>
        <div className={styles.fullPageScrollPaneContent}>{children}</div>
      </div>

      {PageFooter && <div className={styles.fullPageFooter}>{PageFooter}</div>}
    </div>
  );
};
